export default "__VITE_ASSET__BTSshgao__"